<template>
  <tr @click="openItem(item.id)" :class="min ? '' : 'pointer'">
    <td>
      <div :class="min ? 'd-flex align-center' : ''">
        <div class="avatar">
          <div class="avatar_body">
            <img
              :src="item.logo ? apiDomain + '/min/' + item.logo : require('@/assets/svg/ImageNotFound.svg')"
              alt="logo"
            />
          </div>
        </div>
        <div v-if="min" class="ml-4">
          {{ item?.name || '—'}}
        </div>
      </div>
    </td>
    <td v-if="!min">
      {{ item?.name || '—' }}
    </td>
    <td :class="min ? '' : 'text-center'">
      {{ item?.ytunnus || '—' }}
    </td>
    <td :class="min ? '' : 'text-center'">
      {{ item?.vat || '—' }}
    </td>
    <td :class="min ? '' : 'text-center'">
      {{ item?.ovt  || '—'}}
    </td>
    <td :class="min ? '' : 'text-center'">
      {{ item?.operator_id  || '—'}}
    </td>
    <td :class="min ? '' : 'text-center'">
      {{ item?.operator  || '—'}}
    </td>
    <td>
      <div class="buttons">
        <ButtonShow :to-name="openName" :to-params="item.id"/>
        <template
          v-if="$userCheckAccess({  abilities: $route.name.includes('Sales') ? 'edit_invoicing_companies' : 'edit_clients' })">
          <DeleteModal
            :item="item"
            :text="
              localStorage.translations.pages['setting-client']['dialog-delete']['udalit-klienta'] +
              ' ' + item.name
            "
            :delete-id="item.id"
            :method-delete="deleteItem"
          />
        </template>
      </div>
    </td>
  </tr>
</template>

<script>
import DeleteModal from 'components/DeleteModal'
import ButtonShow from 'components/ButtonShow'

export default {
  name: 'WorkClientTableItem',
  components: {ButtonShow, DeleteModal},
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    openName: {
      type: String,
      default: 'clientsCompanyShow'
    },
    onDelete: {}
  },
  computed: {
    apiDomain() {
      return this.$store.state.apiDomain
    },
    min() {
      return this.$vuetify.breakpoint.lgAndDown
    },
  },
  methods: {
    openItem(id) {
      if (!this.min) {
        this.$router.push({
          name: this.openName,
          params: {id: id},
        })
      }
    },
    deleteItem(id) {
      if (this.onDelete) this.onDelete(id)
    }
  },
}
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}

td {
  .avatar {
    height: 100%;
    display: grid;
    justify-content: start;
    align-items: center;

    .avatar_body {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #ffffff;
      border: 1px solid #dbdbdb;
      display: grid;
      justify-content: center;
      align-items: center;
      transition: inherit;

      img, svg {
        border-radius: inherit;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }

  &:nth-child(1) {
    width: max-content;
  }

  &:nth-child(2) {
    width: auto;
  }

  &:nth-child(3) {
    width: auto;
  }

  &:nth-child(4) {
    width: auto;
  }
}
</style>
